import { useState } from "react";
import { useTranslation } from "react-i18next";
// Components
import { InfoMainDiv, InfoButton, InfoText, InfoArrowImg, IndicatorDiv } from "./styles";
// Assets
import ArrowDown from "../../../../assets/icons/ico_arrow_down_black.svg";
import ArrowUp from "../../../../assets/icons/ico_arrow_up_black.svg";

const PrescriptionsInfo = () => {
  const [isShowInfo, setIsShowInfo] = useState(false);
  const [t] = useTranslation("global");

  const showInfo = (e) => {
    e.preventDefault();
    setIsShowInfo(!isShowInfo);
  };

  return (
    <InfoMainDiv>
      <InfoButton onClick={showInfo}>
        <InfoText>{t("informationButton_title")}</InfoText>
        <InfoArrowImg src={isShowInfo ? ArrowUp : ArrowDown} alt="arrow" />
      </InfoButton>
      <IndicatorDiv display={isShowInfo ? "flex" : "none"}>
        <InfoText>{t("prescriptions_prescriptionsIndication")}</InfoText>
        <InfoText>{t("prescriptions_reportsIndication")}</InfoText>
      </IndicatorDiv>
    </InfoMainDiv>
  );
};

export default PrescriptionsInfo;
